const NotFound = () => import('./404.vue')

export default {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: NotFound,
}
